<template>
  <transition appear name="from-below">
    <v-row class="my-4 content-social" no-gutters >
      <v-col cols="auto" class="px-0" v-if="data && data.website">
        <v-btn aria-label="Website" data-cursor-target icon target="_blank" rel="noopener" :href="data.website"><WebsiteIcon /></v-btn>
      </v-col>
      <v-col cols="auto" class="px-0" v-if="data && data.facebook">
        <v-btn aria-label="Facebook" data-cursor-target icon target="_blank" rel="noopener" :href="data.facebook"><FacebookIcon /></v-btn>
      </v-col>
      <v-col cols="auto" class="px-0" v-if="data && data.instagram">
        <v-btn aria-label="Instagram" data-cursor-target icon target="_blank" rel="noopener" :href="data.instagram"><InstagramIcon /></v-btn>
      </v-col>
    </v-row>
  </transition>
</template>

<script>
import FacebookIcon from '@/assets/img/facebook-icon.svg'
import InstagramIcon from '@/assets/img/instagram-icon.svg'
import WebsiteIcon from '@/assets/img/world-icon.svg'

export default {
  name: 'ContentSocial',
  components: {
    FacebookIcon,
    InstagramIcon,
    WebsiteIcon
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped lang="scss">

.content-social {
  path {
    fill: currentColor !important;
  }

  path[stroke-width] {
    stroke: currentColor !important;
  }

  svg {
    color: map-get($shades, 'black');
    width: 18px;
    height: 18px;
  }
}

</style>
